import React, { useEffect, useState, useRef } from "react";
import { IoIosSquareOutline } from "react-icons/io";
import { optionsBranch } from "../data/branch-data";
import { internType } from "../data/interntype-data";
import {
  changePrefixName,
  convertDateThai,
  convertTime,
  matchOptions,
} from "../utils/function";
import { useSelector } from "react-redux";
import { useReactToPrint } from "react-to-print";

const InternPageReview = ({ data, readOnly }) => {
  const profile = useSelector((state) => state.profileReducer.profile);
  const [postStatus, setPostStatus] = useState("");
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  useEffect(() => {
    if (!data) {
      return;
    } else {
      const { status_id } = data;

      if (status_id == 12 || status_id == 14) {
        setPostStatus(status_id);
      }
    }
  }, [data]);

  const levelRaw = +data?.school_yrs?.slice(-2) + 1 - +data?.id.slice(0, 2);
  const level = levelRaw <= 4 ? levelRaw : 4;

  const displayHeader = (
    <div>
      <div className="d-flex">
        <div className="me-3">
          <img src="./assets/images/buu-logo.png" alt="buu logo" width="60px" />
        </div>
        <div className="fw-bold-9 text-dark">
          <div>แบบฟอร์มแจ้งความประสงค์ขอฝึกงานและปฎิบัติสหกิจศึกษา</div>
          <div>
            Cooperative Education Faculty of Engineering Burapha University
          </div>
        </div>
      </div>
      <hr />
    </div>
  );

  const displayProfile = (
    <div className="mb-4">
      <div>
        <span className="fw-bold-9">ข้าพเจ้า</span> {data?.name}
        <span className="fw-bold-9 ms-4">รหัสนิสิต</span> {data?.id}
        <span className="fw-bold-9 ms-4">ชั้นปีที่ </span>
        {level}
      </div>
      <div>
        <span className="fw-bold-9">สาขาวิชา </span>
        {matchOptions(optionsBranch, data?.b_id)}
        <span className="fw-bold-9 ms-4">เกรดเฉลี่ย </span>
        {!!data?.gpa && (+data?.gpa).toFixed(2)}
      </div>
      <div>
        <span className="fw-bold-9 me-2">หมายเลขโทรศัพท์ </span>{" "}
        {data?.st_tel ?? "-"}
        <span className="fw-bold-9 ms-4">E-mail : </span> {data?.st_mail ?? "-"}
      </div>
      <div className="fw-bold-9">
        ขอแจ้งความประสงค์ขอฝึกงานและปฏิบัติสหกิจศึกษา ปีการศึกษา
        <span className="ms-2">{data?.school_yrs}</span>
      </div>
    </div>
  );

  const displayTypeIntern = (
    <div className="mb-4">
      <div>
        <span className="fw-bold-9">ประเภทการฝึกงาน : </span>
        {matchOptions(internType, data?.internDetail?.type_internship)}
      </div>
      <div>
        <span className="fw-bold-9">ช่วงวันที่ </span>
        {convertDateThai(data?.internDetail?.start_date)} -
        {convertDateThai(data?.internDetail?.end_date)}
      </div>
    </div>
  );
  const displayCompany = (
    <div>
      <div>
        <span className="fw-bold-9">ข้อมูลสถานประกอบการ</span>
      </div>
      <div>{data?.companyDetail?.name}</div>
      <div>
        <span className="fw-bold-9 ">ที่อยู่ </span>
        {data?.companyDetail?.address} ต.
        {data?.companyDetail?.subdistrict}
        อ.{data?.companyDetail?.district} จ.
        {data?.companyDetail?.province} {data?.companyDetail?.zip}
      </div>
      <div>
        <span className="fw-bold-9 me-2">ผู้ประสานงาน </span>
        {changePrefixName(data?.internDetail?.co_name)}
        <span className="fw-bold-9 ms-2">ตำแหน่ง </span>
        {data?.internDetail?.co_pos}
      </div>
      <div> </div>
      <div>
        <span className="fw-bold-9 me-2">E-mail </span>
        {data?.internDetail?.co_email || "-"}
        <span className="fw-bold-9 mx-2">หมายเลขโทรศัพท์</span>
        {data?.internDetail?.cp_tel || "-"}
      </div>
    </div>
  );

  const displaySign = (
    <div className="mt-6 mb-2">
      <div className="text-center">
        <div>
          <span className="fw-bold-9">ผู้ขอ</span>
          <span style={{ color: "#0001A4" }}> {data?.name}</span>
        </div>
        {!!data?.internDetail?.date_create && (
          <div>
            {convertDateThai(data?.internDetail?.date_create)}
            <span className="ms-2">
              {convertTime(data?.internDetail?.date_create, "เวลา", "น.")}
            </span>
          </div>
        )}
      </div>
    </div>
  );

  const displayCheck = (
    <div>
      <div className="d-flex align-items-center">
        <div className="form-check mb-0 me-3">
          <input
            className="form-check-input"
            type="radio"
            name="flexRadioDefault"
            id="intern-passed"
            disabled={readOnly}
            defaultChecked={
              data && data?.internDetail?.status == 2 ? true : false
            }
            value={12}
            onChange={(ev) => setPostStatus(ev.target.value)}
          />
          <label className="" htmlFor="intern-passed">
            ผ่านเกณฑ์การฝึกงาน
          </label>
        </div>
        <div className="form-check mb-0">
          <input
            className="form-check-input"
            type="radio"
            disabled={readOnly}
            name="flexRadioDefault"
            id="intern-notpassed"
            defaultChecked={
              data && data?.internDetail?.status == 0 ? true : false
            }
            value={14}
            onChange={(ev) => setPostStatus(ev.target.value)}
          />
          <label className="" htmlFor="intern-notpassed">
            ไม่ผ่านเกณฑ์การฝึกงาน
          </label>
        </div>
      </div>
    </div>
  );

  const displayReviewer = (
    <div className="mt-6   mb-4 text-center">
      <div>
        <span className="fw-bold-9">ผู้ตรวจ </span>
        <span style={{ color: "#0001A4" }} className="">
          {data?.internDetail?.approveby || profile?.name}
        </span>
      </div>
      <div>
        อาจารย์ผู้ประสานงานสาขาวิชา {matchOptions(optionsBranch, data?.b_id)}
      </div>
      {!!data?.internDetail?.date_approve && (
        <div>
          {convertDateThai(data?.internDetail?.date_approve)}
          <span className="ms-2">
            {convertTime(data?.internDetail?.date_approve, "เวลา", "น.")}
          </span>
        </div>
      )}
    </div>
  );

  const displayBtn = (
    <div
      className=" my-2 d-flex justify-content-between align-items-center"
      id="section-to-not-print"
    >
      <div>
        ตรวจสอบข้อมูลจากระบบทะเบียน
        <a
          target="_blank"
          className="ms-2"
          href={`http://reg.buu.ac.th/registrar/studentByProgram_1.asp?vcmd=14&studentcode=${data?.id}`}
        >
          reg.buu.ac.th
        </a>
      </div>
      <div id="section-to-not-print">
        <button
          type="submit"
          className="btn btn-primary mx-2"
          onClick={(ev) => {
            setPostStatus(13);
          }}
          style={{ fontSize: "20px" }}
        >
          ติดต่อ อ. ผู้ประสานงาน
        </button>
        <button
          className="btn btn-success mx-2"
          disabled={postStatus ? false : true}
          type="submit"
          style={{ fontSize: "20px" }}
        >
          ยืนยัน
        </button>
      </div>
    </div>
  );

  const displayApprove = (
    <div className="text-center">
      <div
        className="text-center"
        style={{
          borderRadius: "15px",
          fontSize: "30px",
          width: "200px",
          padding: "10px",
          border: "4px solid #0001A4",
          color: "#0001A4",
          // transform: "rotate(-10deg)",
          margin: "auto",
        }}
      >
        อนุมัติคำขอ
      </div>
    </div>
  );
  const displayNotApprove = (
    <div className="text-center">
      <div
        className="text-center"
        style={{
          borderRadius: "15px",
          fontSize: "30px",
          width: "200px",
          padding: "10px",
          border: "4px solid red",
          color: "red",
          // transform: "rotate(-10deg)",
          margin: "auto",
        }}
      >
        ไม่อนุมัติคำขอ
      </div>
    </div>
  );

  return (
    <div>
      <section
        className="sheet   print-container react-print-container"
        style={{ color: "black" }}
        id="section-to-print"
        ref={componentRef}
      >
        <div className="row">
          <div className="col-12 mb-3">{displayHeader}</div>
          <div className="col-9">
            {displayProfile}
            {displayTypeIntern}
          </div>
          <div className="col-3 text-end">
            <img
              src={`http://reg.buu.ac.th/registrar/getstudentimage.asp?id=${data?.id}`}
              width="120px"
            />
          </div>
          <div className="col-12">{displayCompany}</div>
          <div className="col-6"></div>
          <div className="col-6">{displaySign}</div>
          <hr />
          <div className="col-12">{displayCheck}</div>
          <div className="col-6"></div>
          <div className="col-6">
            {data?.internDetail?.status == 2
              ? displayApprove
              : data?.internDetail?.status == 0
              ? displayNotApprove
              : ""}
            {displayReviewer}
          </div>
          <hr />

          {data?.internDetail?.status != 1 && (
            <div className="mb-2">
              <small>
                ***
                เอกสารนี้ใช้สำหรับแจ้งความประสงค์ขอฝึกงานและปฏิบัติสหกิจศึกษากับทางคณะเท่านั้น
              </small>
              <br />
              <small style={{ textIndent: "18px" }}>
                เมื่ออาจารย์ผู้ประสานงานอนุมัติคำขอทางคณะจะออกหนังสือขอความอนุเคราะห์ฝึกงาน
                เพื่อนำส่งไปยังสถานประกอบการ
              </small>
            </div>
          )}

          {!readOnly && (
            <>
              <form action="./update-intern-status.php" method="post">
                <input
                  name="req_id"
                  className="d-none"
                  value={data?.internDetail?.req_id}
                />
                <input name="st_id" className="d-none" value={data?.id} />
                <input name="user" className="d-none" value={profile?.name} />
                <input
                  name="post_status"
                  className="d-none"
                  value={postStatus}
                />
                {displayBtn}
              </form>
              <div className="">
                สามารถดูเกณฑ์การฝึกงาน ตามประกาศเลขที่{" "}
                <a
                  href="https://drive.google.com/file/d/1-Oiw5Yyo6lg8qOOh8sk73TNcg6oG7xJ4/view?usp=sharing"
                  target="_blank"
                >
                  113/2565
                </a>
              </div>
            </>
          )}
        </div>
      </section>
      <div className="text-center" id="section-to-not-print">
        <button className="btn btn-outline-primary " onClick={handlePrint}>
          พิมพ์เอกสาร
        </button>
      </div>
    </div>
  );
};

export default InternPageReview;
